'use client';

import { useMediaQuery } from 'hooks/useMediaQuery';
import { theme } from '@frameio/vapor-theme';

/**
 * Returns the active window breakpoint. Note, this is _not_ SSR friendly and
 * you should opt for CSS if possible.
 */
export function useActiveWindowBreakpoint(): keyof typeof theme.breakpoints {
  const breakpoints = theme.breakpoints;

  const tablet = useMediaQuery(`(min-width: ${breakpoints.tablet})`);
  const desktop = useMediaQuery(`(min-width: ${breakpoints.desktop})`);
  if (desktop) return 'desktop';
  if (tablet) return 'tablet';
  return 'base';
}
